import React from 'react'

// import type { Theme } from '@material-ui/core'
// import { makeStyles } from '@material-ui/core'
import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'
import { usePresentationNav } from '../../PresentationNav'

import QuoteComponent from '../../../Quote/Quote'
import QuotePlaceholder from './QuotePlaceholder'
import AnimationWrapper from '../../util/AnimationWrapper'

import ButtonBlock from '../Button/ButtonBlock'

// const useStyles = makeStyles((_theme: Theme) => ({
//   root: {},
//   content: {},
//   acceptDiv: {
//     display: 'flex',
//     width: '100%',
//     justifyContent: 'flex-end'
//   },
//   acceptPrice: {
//     fontSize: '55px',
//     fontWeight: 'lighter'
//   }
// }))

function QuoteBlock(props: PresentationBlockProps) {
  // const classes = useStyles(props)
  const { isQuoteEmpty } = usePresentationNav()
  if (isQuoteEmpty) return null
  const { WrapperComponent, isSettings, block, useCart, objectLabels } = props

  const animation = block.fields?.animation

  if (useCart) {
    return <ButtonBlock cartLink={true} {...props} />
  } else
    return (
      <>
        <WrapperComponent {...props}>
          <AnimationWrapper animation={animation} index={0} direction={'top'}>
            <div>
              {isSettings ? <QuotePlaceholder objectLabels={objectLabels} /> : <QuoteComponent inPresentation={true} />}
            </div>
          </AnimationWrapper>
        </WrapperComponent>
      </>
    )
}

export default React.memo(QuoteBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
